var glegem = glegem || function(){(window["glegem"].q = window["glegem"].q || []).push(arguments)};
glegem("OnBeforeSwitcher",function(e) {
    var html = "";
    var country = e.country;

    if (country !== "US" && country !== "CA") {
        document.body.classList.add('ge-markets');
    }

    document.body.classList.add('ge-' + country.toLowerCase());

    e.onComplete([{key : "clientSwitcherDynamicContent", value : html}]);
});

